import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { ModalBase } from '../../../common/components';

// components
import AppointmentProfileReports from './AppointmentProfileReports';

function AppointmentProfileReportsModal() {
  const dispatch = useDispatch();
  const {
    appointmentProfileReportsModal,
  } = useSelector(store => store.modals);

  function closeAction() {
    dispatch({ type: 'CLOSE_MODAL', modal: 'appointmentProfileReportsModal' });
  }

  return (
    <ModalBase
      allowOverlayClickClose
      isOpen={appointmentProfileReportsModal}
      closeModalAction={() => closeAction()}
      staticWidth="600px"
    >
      <AppointmentProfileReports />
    </ModalBase>
  );
}

export default AppointmentProfileReportsModal;
